export const getWatermarkText = (currentUser) => {
  return currentUser?.watermark_text;
};

export const getSignedWatermarkText = (currentUser) => {
  return currentUser?.signed_watermark_text;
};
